<script>
    import DeployLocalBackupView from "./BackupModalViews/DeployLocalBackupView";
    import UploadLocalLibraryBackupView from "./BackupModalViews/UploadLocalLibraryBackupView.vue";

    export default {
        props: {
            regions: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                selectedBackup: undefined,
                modalData: {
                    show: false,
                    component: undefined,
                    componentProps: {}
                }
            };
        },
        methods: {
            showUploadBackupPopUp() {
                this.modalData.componentProps = {};
                this.modalData.component = UploadLocalLibraryBackupView;
                this.modalData.show = true;
            },
            showDeployPopUp(backupFileName) {
                this.modalData.componentProps = {backupFileName: backupFileName, regions: this.regions};
                this.modalData.component = DeployLocalBackupView;
                this.modalData.show = true;
            },
            closeModal() {
                this.modalData.show = false;
                this.modalData.component = undefined;
                this.modalData.componentProps = {};
            }
        }
    };
</script>

<style lang="scss" scoped>
    .controls {
        display: flex;
        justify-content: flex-end;
        padding: 0.75rem;
    }
</style>
